<!--<input type="file" (change)="onFileSelected($event)">-->
<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <img src="./assets/images/loading04.gif" alt="loading" style="width: 300px;" />
    <!-- <p style="color: black" class="card-title">กำลังโหลดข้อมูล...</p> -->
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <!-- แบบค้นหาข้อมูล -->
        <div class="card no-print">
            <div class="card-header bg-purple">
                <i class="fas fa-clipboard-list"></i>
                ขอบาร์โค้ดคิว(สำหรับอ้อยส่งลาน)
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-md-2 text-center">
                        <mat-form-field class="example-full-width" appearance="fill">
                            <mat-label>โควตา10หลัก</mat-label>
                            <input matInput required placeholder="รหัสชาวไร่ 10 หลัก" [(ngModel)]="fmcode"
                                maxlength="10" name="fmcode">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2 text-center">
                        <div class="button-row">
                            <button mat-raised-button color="primary" (click)="plot_data();LoadDataLists();"
                                [disabled]="fmcode.length!=10">
                                ตกลง/รีเฟรช
                            </button>
                        </div>
                    </div>
                    <!--<div class="col-md-2 text-center">
                        <input type="file" multiple (change)="onFileChange($event)" accept="application/pdf">
                    </div>-->
                    <div class="col"></div>
                </div>
                <hr />
                <div class="row">
                    <div class="col"></div>
                    <div class="col-md-10">
                        <div class="example-label">รายการแปลงอ้อย {{plot_d.length}} : แปลง </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr style="text-align:center">
                                    <th>.</th>
                                    <th>ปี</th>
                                    <th>เลขแปลง</th>
                                    <th>ขื่อ</th>
                                    <th>พื้นที่</th>
                                    <th>ประเภทอ้อย</th>
                                    <th>กลุ่มตัด</th>
                                    <th>โซน</th>
                                    <th>ประเมิน</th>
                                    <th>ปริมาณตัน</th>
                                    <th>อ้อยเข้า</th>
                                    <th colspan="2">***</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="text-align:center" *ngFor="let dt of plot_d; index as i;">
                                    <td> {{i+1}}</td>
                                    <td> {{dt.year}}</td>
                                    <td> {{dt.intlandno}}</td>
                                    <td style="text-align:left"> {{dt.fmname}}</td>
                                    <td style="text-align:right"> {{dt.landvalue|number:'1.2-2'}}</td>
                                    <td> {{dt.canetype}}</td>
                                    <td> {{dt.groupCode}}</td>
                                    <td> {{dt.supzone}}</td>
                                    <td> {{dt.Ton}}</td>
                                    <td style="text-align:right"> {{dt.Assess|number}}</td>
                                    <td style="text-align:right"> {{dt.canein|number}}</td>
                                    <td>
                                        <input matInput type="number" min="0" max="100" placeholder="จำนวน"
                                            style="text-align:center; background: #fffcad;" [ngModel]="dt.num"
                                            (ngModelChange)="dt.num = $event;">
                                    </td>
                                    <td>
                                        <button class="btn btn-success btn-sm" type="submit" [disabled]="!dt.num>0"
                                            (click)="addToQcard(dt)">บันทึก</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col"></div>
                </div>

                <hr />

                <div class="row">
                    <div class="col"></div>
                    <div class="col-md-10">
                        <div class="example-label">รายการที่ขอเพิ่มไปแล้ว {{DataList.length}} : รายการ </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr style="text-align:center">
                                    <th>.</th>
                                    <th>ปี</th>
                                    <th>เลขแปลง</th>
                                    <th>ขื่อชาวไร่</th>
                                    <th>จำนวนเที่ยว</th>
                                    <th>วันที่ขอ</th>
                                    <th>ชื่อผู้ขอ</th>
                                    <th>เริ่มต้น</th>
                                    <th>สุดทัาย</th>
                                    <th><span class="material-icons">print</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="text-align:center" *ngFor="let dt of DataList; index as i;">
                                    <td> {{i+1}}</td>
                                    <td> {{dt.year}}</td>
                                    <td> {{dt.landno}}</td>
                                    <td style="text-align:left"> {{dt.fmname}}</td>
                                    <td> {{dt.amount}}</td>
                                    <td> {{THtoLocal(dt.dateAdd)}}</td>
                                    <td style="text-align:left"> {{dt.userNameAdd}}</td>
                                    <td> {{dt.truck_q1}}</td>
                                    <td> {{dt.truck_q2}}</td>
                                    <td> <a [routerLink]="['/printbarcode/'+dt.truck_q1+'/'+dt.truck_q2]"
                                            class="nav-link" target="_blank">
                                            <span class="material-icons" style="color: red;">print</span>
                                        </a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col"></div>
                </div>

                <hr />
            </div>
        </div>
    </div>
</div>



<app-footer></app-footer>